import { colors } from '../styles/theme';

/**
 * The one discreet line under any surface that shows a percentage, a projection,
 * or product terms: the figures are informational, never a promised rate, so no
 * surface drifts into promissory language. Risk is disclosed in the contract and
 * the offering document, not on screens (owner, 2026-10-14).
 */
interface Props {
  /** Extra sentence appended after the standard text (e.g. projection-specific caveats). */
  readonly extra?: string;
  /** Tighter spacing for card footers vs full-width page sections. */
  readonly compact?: boolean;
}

export default function RiskDisclaimer({ extra, compact = false }: Props): JSX.Element {
  return (
    <p
      style={{
        margin: 0,
        padding: compact ? '8px 0 0' : '12px 0 0',
        fontSize: 12,
        color: colors.muted,
        lineHeight: 1.5,
      }}
    >
      Private placement for eligible investors. Figures are for informational
      purposes and are not promised rates: you receive your share of what the
      series actually earns.
      {extra ? ` ${extra}` : ''}
    </p>
  );
}
